module.exports = __webpack_public_path__ + "img/nav_icon.69d27b36.svg";